class ShPredictiveSearch {
  constructor(input) {
    this.input = input;
    this.controller = null;
    this.timer = null;

    this.panel = document.createElement('div');
    this.panel.className = 'sh-predictive-search-panel';
    this.panel.hidden = true;

    document.body.appendChild(this.panel);

    this.bind();
    this.positionPanel();
  }

  bind() {
    this.input.addEventListener('input', () => {
      clearTimeout(this.timer);

      const term = this.input.value.trim();

      if (term.length < 2) {
        this.close();
        return;
      }

      this.timer = setTimeout(() => {
        this.fetchResults(term);
      }, 180);
    });

    this.input.addEventListener('focus', () => {
      if (this.panel.innerHTML.trim()) {
        this.positionPanel();
        this.open();
      }
    });

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        this.input.blur();
      }
    });

    document.addEventListener('click', (event) => {
      if (
        event.target !== this.input &&
        !this.panel.contains(event.target)
      ) {
        this.close();
      }
    });

    window.addEventListener('resize', () => {
      if (!this.panel.hidden) {
        this.positionPanel();
      }
    });

    window.addEventListener('scroll', () => {
      if (!this.panel.hidden) {
        this.positionPanel();
      }
    }, { passive: true });
  }

  positionPanel() {
    const rect = this.input.getBoundingClientRect();

    const viewportWidth = window.innerWidth;

    if (viewportWidth <= 749) {
      const sideGap = 8;

      this.panel.style.left = `${sideGap}px`;
      this.panel.style.right = `${sideGap}px`;
      this.panel.style.width = 'auto';
      this.panel.style.top = `${rect.bottom + 8}px`;

      return;
    }

    const width = Math.min(
      1000,
      viewportWidth - 40
    );

    let left = rect.left + (rect.width / 2) - (width / 2);

    left = Math.max(20, left);
    left = Math.min(left, viewportWidth - width - 20);

    this.panel.style.width = `${width}px`;
    this.panel.style.left = `${left}px`;
    this.panel.style.right = 'auto';
    this.panel.style.top = `${rect.bottom + 10}px`;
  }

  async fetchResults(term) {
    if (this.controller) {
      this.controller.abort();
    }

    this.controller = new AbortController();

    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

 const url =
  `${root}search/suggest` +
  `?q=${encodeURIComponent(term)}` +
  `&resources[type]=product,article` +
  `&resources[limit]=6` +
  `&resources[limit_scope]=each` +
  `&resources[options][unavailable_products]=hide` +
  `&resources[options][fields]=title,product_type,variants.title,vendor` +
  `&resources[options][prefix]=last` +
  `&section_id=sh-predictive-search`;

    try {
      const response = await fetch(url, {
        signal: this.controller.signal
      });

      if (!response.ok) {
        this.close();
        return;
      }

      const html = await response.text();

      const parsed =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );

      const results =
        parsed.querySelector(
          '#sh-predictive-search-results'
        );

      if (!results) {
        this.close();
        return;
      }

      this.panel.innerHTML = results.outerHTML;

      this.positionPanel();
      this.open();

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(
          'Sh! predictive search:',
          error
        );
      }
    }
  }

  open() {
    this.panel.hidden = false;
  }

  close() {
    this.panel.hidden = true;
  }
}


function initShPredictiveSearch() {
  const inputs = document.querySelectorAll(
    [
      'input[type="search"]',
      'input[name="q"]',
      '.search__input',
      '.predictive-search__input'
    ].join(',')
  );

  inputs.forEach((input) => {
    if (
      input.dataset.shPredictiveSearch === 'true'
    ) {
      return;
    }

    input.dataset.shPredictiveSearch = 'true';

    new ShPredictiveSearch(input);
  });
}


document.addEventListener(
  'DOMContentLoaded',
  initShPredictiveSearch
);

document.addEventListener(
  'shopify:section:load',
  initShPredictiveSearch
);